import axios from "axios";
import Config from "@/config"

export default class FaqService {
    getFaqs(accessToken, locale) {
        const options = {
            headers: {
                ...Config.headers(accessToken), ...{},
            }
        };
        return axios
            .get(
                Config.proxy + Config.url("faqs") + "?locale=" + locale,
                options
            )
            .then(res => res.data.data)
            .catch(
                function (error) {
                    console.log('Show error notification!')
                    return Promise.reject(error)
                }
            )

    }
}